import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de8b74867a3b99/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de8b74867a3b99/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8de8b74867a3b99/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de8b74867a3b99/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de8b74867a3b99/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/app/[locale]/branchen/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/node_modules/next/dist/client/link.js");
